import { styled } from "@mui/material"
import { Grid } from "./Grid"

export const AlternativeLoginButtons = styled(Grid)({ rowGap: "16px" })
